import React, { useState, useEffect, useRef, useCallback } from 'react';
import { parseURL } from '../../sc-utilities';
import { withStyles, Dialog, Typography } from '@material-ui/core';
import * as actions from './store/searchAction';
import { connect } from 'react-redux';
import ProductTable from './Product';
import { hasPermission } from '../../sc-utilities';
import AppLogoLoading from '../../sc-logo';
import { useLocation } from 'react-router-dom';
import { MuiTableRows } from '../../../themes';

const styles = (theme) => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%',
        },
    },
    logo: {
        width: '250px',
        margin: '10px',
    },
    logoRoot: {
        backgroundColor: 'transparent',
    },
    logoPaper: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        overflow: 'hidden',
    },
});

const SearchList = (props) => {
    const { classes, search, onFetchSearch, activeCustomerID, translations, permissions, onClearState } = props;
    const searchURLParams = parseURL(decodeURIComponent(window.location.search));
    const [searchParams, setSearchParams] = useState(
        searchURLParams && searchURLParams.searchInput
            ? searchURLParams
            : search.lastSearchParams
            ? search.lastSearchParams
            : ''
    );
    const [loading, setLoading] = useState(false);

    const [tableOptions] = useState({
        filtering: false,
        sorting: false,
        selection: false,
        exportFileName: 'Products',
        filterCellStyle: { maxWidth: '200px' },
        search: false,
        minBodyHeight: window.innerHeight - 350 < 280 ? 280 : window.innerHeight - 350,
        maxBodyHeight: window.innerHeight - 350,
        pageSizeOptions: [20, 50, 100],
        exportButton: false,
        loading: true,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
        },
        columnsButton: true,
        pageSize: 20,
        emptyRowsWhenPaging: false,
    });

    const location = useLocation();
    const tableRef = useRef();

    const fetchTableData = useCallback(
        async (query) => {
            const fetchData = async (query) => {
                setLoading(true);

                const { searchInput, ...booleanParams } = searchParams;

                Object.keys(booleanParams).forEach(
                    (param) => (booleanParams[param] = JSON.parse(booleanParams[param]))
                );

                const result = await onFetchSearch({
                    SearchInput: searchInput,
                    ...booleanParams,
                    ActiveCustomerID: activeCustomerID,
                    query,
                });
                setLoading(false);
                return result;
            };

            if (searchParams !== '') {
                const result = await fetchData(query);
                return {
                    data: result?.data?.products || [],
                    page: query?.page || 0,
                    pageSize: query?.pageSize,
                    totalCount: result?.data?.totalCount || 0,
                };
            }
        },
        [onFetchSearch, searchParams, activeCustomerID, onClearState]
    );

    useEffect(() => {
        const searchURLParams = parseURL(decodeURIComponent(location.search));

        searchURLParams.searchInput = searchURLParams.searchInput?.replace(/['()*]/g, '#');

        let queryParams = [];

        for (const param in searchURLParams) {
            queryParams.push(`${param}=${encodeURIComponent(searchURLParams[param])}`);
        }

        window.history.pushState({ path: `/search?${queryParams.join('&')}` }, '', `/search?${queryParams.join('&')}`);
        setSearchParams(searchURLParams);
        tableRef.current && tableRef.current.onQueryChange();
    }, [location.search]);

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'global_search') ? (
                <>
                    {!loading && (!search || !search.products || search.products.length === 0) ? (
                        <Typography variant={'caption'}>
                            {translations['there_is_no_results_for_entered_phrase'] ||
                                `There are no results for entered phrase.`}
                        </Typography>
                    ) : null}
                    {hasPermission(permissions, 'product_list') ? (
                        <ProductTable
                            tableRef={tableRef}
                            fetchTableData={fetchTableData}
                            tableOptions={tableOptions}
                            translations={translations}
                            activeExternalServiceAvailable={props.activeExternalServiceAvailable}
                            permissions={permissions}
                        />
                    ) : null}
                    <Dialog
                        disableBackdropClick={true}
                        open={loading}
                        PaperProps={{ classes: { root: classes.logoPaper } }}
                    >
                        <AppLogoLoading />
                    </Dialog>
                </>
            ) : null}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        activeExternalServiceAvailable: state.core.login.activeExternalServiceAvailable,
        search: state.statistic.searches.list,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onClearState: () => dispatch(actions.ClearStateCreate()),
        onFetchSearch: (search) => dispatch(actions.fetchSearch(search)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SearchList));
